(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/route-result/assets/javascripts/highscore/highscore-list.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/route-result/assets/javascripts/highscore/highscore-list.js');
"use strict";

const {
  useContext,
  useEffect,
  useState,
  useCallback
} = React;
const {
  ReactButton
} = svs.ui;
const {
  useDispatch
} = ReactRedux;
const {
  fetchCompetitionHighscore
} = svs.components.marketplaceCompetition.services.actions.highscoreResultActions;
const {
  useSelector
} = ReactRedux;
const {
  ReactIntersectionObserver
} = svs.components.lbUtils.intersectionObserver;
const {
  HighscoreContext,
  HighScoreListItem
} = svs.components.marketplaceCompetition.routeResult.highscore;
const {
  selectCompetitionResult,
  selectCompetitionResultPending,
  selectCompetitionResultComplete
} = svs.components.marketplaceCompetition.services.selectors.competitionResultSelectors;
const {
  useCompetitionId
} = svs.components.marketplaceCompetition.competitionContext;
const {
  useCompetitionType,
  useGetCompetitionResultCount
} = svs.components.marketplaceCompetition.services.hooks;
const HighscoreList = () => {
  var _useGetCompetitionRes;
  const {
    typeDescription,
    type,
    searchTerm,
    count,
    offset,
    setOffset
  } = useContext(HighscoreContext);
  const [autoLoadActive, setAutoLoadActive] = useState(false);
  const dispatch = useDispatch();
  const competitionId = useCompetitionId();
  const list = useSelector(state => selectCompetitionResult(state, competitionId, type, 30));
  const totalCount = (_useGetCompetitionRes = useGetCompetitionResultCount({
    competitionId,
    type
  })) !== null && _useGetCompetitionRes !== void 0 ? _useGetCompetitionRes : 0;
  const listIsPending = useSelector(state => selectCompetitionResultPending(state, competitionId, type));
  const resultDone = useSelector(state => selectCompetitionResultComplete(state, competitionId, type));
  const competitionType = useCompetitionType(competitionId);
  useEffect(() => {
    setAutoLoadActive(false);
  }, [type, searchTerm]);
  useEffect(() => {
    dispatch(fetchCompetitionHighscore({
      competitionId,
      payloadType: type,
      count,
      offset,
      search: searchTerm,
      type: competitionType
    }));
  }, [competitionId, count, dispatch, offset, type, searchTerm, competitionType]);
  const loadMoreCallback = useCallback(() => {
    setOffset(offset + count);
  }, [count, offset, setOffset]);
  const intersectionCallback = useCallback(_ref => {
    let {
      isIntersecting
    } = _ref;
    if (isIntersecting) {
      loadMoreCallback();
    }
  }, [loadMoreCallback]);
  const noResults = !list || list.length < 1;
  if (noResults) {
    return React.createElement("div", {
      className: "highscore-list-container f-center"
    }, React.createElement("p", null, "Inga resultat hittades"));
  }
  const shouldShowMoreButton = !noResults && !resultDone && !listIsPending;
  return React.createElement("div", {
    className: "highscore-list-container"
  }, React.createElement("div", {
    className: "highscore-header-container"
  }, React.createElement("span", {
    className: "highscore-header-position"
  }, React.createElement("abbr", {
    title: "Position"
  }, "Pos.")), React.createElement("span", {
    className: "highscore-header-type"
  }, typeDescription, ' ', "(", totalCount, ' ', "st)"), React.createElement("span", {
    className: "highscore-header-drawpoints"
  }, React.createElement("abbr", {
    title: "Omg\xE5ngens po\xE4ng"
  }, "Omg.")), React.createElement("span", {
    className: "highscore-header-totalpoints"
  }, React.createElement("abbr", {
    title: "Totalt antal po\xE4ng"
  }, "Tot."))), React.createElement("div", {
    className: "highscore-body-container"
  }, list && list.map(el => React.createElement(HighScoreListItem, {
    competitionId: competitionId,
    el: el,
    key: el.uid,
    type: type
  }))), React.createElement(ReactIntersectionObserver, {
    isObserving: shouldShowMoreButton && autoLoadActive,
    onIntersection: intersectionCallback
  }, shouldShowMoreButton && React.createElement(ReactButton, {
    className: "btn-highscore-more",
    inverted: true,
    onClick: () => {
      loadMoreCallback();
      setAutoLoadActive(true);
    }
  }, "Visa fler")));
};
setGlobal('svs.components.marketplaceCompetition.routeResult.highscore.HighscoreList', HighscoreList);

 })(window);